import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
//import App from "./App";
import * as serviceWorker from "./serviceWorker";
//ReactDOM.render(<App />, document.getElementById("root"));
import { createBrowserHistory } from "history";

import Game from "./TicTacToe";
ReactDOM.render(<Game />, document.getElementById("root"));

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
